(function () {
  'use strict';

  const countdownSelector = '[data-product-countdown]';
  let timer = null;

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function updateCountdown(element, now) {
    const endTime = Date.parse(element.dataset.saleEnd);

    if (!Number.isFinite(endTime)) {
      element.hidden = true;
      return;
    }

    const remaining = endTime - now;

    if (remaining <= 0) {
      element.hidden = true;
      element.dataset.expired = 'true';
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    element.querySelector('[data-countdown-days]').textContent = pad(days);
    element.querySelector('[data-countdown-hours]').textContent = pad(hours);
    element.querySelector('[data-countdown-minutes]').textContent = pad(minutes);
    element.querySelector('[data-countdown-seconds]').textContent = pad(seconds);

    element.hidden = false;
  }

  function updateAllCountdowns() {
    const now = Date.now();

    document.querySelectorAll(countdownSelector).forEach(function (element) {
      if (element.dataset.expired !== 'true') {
        updateCountdown(element, now);
      }
    });
  }

  function initializeCountdowns() {
    updateAllCountdowns();

    if (timer === null) {
      timer = window.setInterval(updateAllCountdowns, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeCountdowns);
  } else {
    initializeCountdowns();
  }

  document.addEventListener('shopify:section:load', initializeCountdowns);

  new MutationObserver(function (mutations) {
    const hasNewCountdown = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        return node.nodeType === 1 &&
          (node.matches?.(countdownSelector) ||
           node.querySelector?.(countdownSelector));
      });
    });

    if (hasNewCountdown) {
      initializeCountdowns();
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
